import { render, staticRenderFns } from "./MedicalAlertDelete.vue?vue&type=template&id=ee71505c&scoped=true&"
import script from "./MedicalAlertDelete.vue?vue&type=script&lang=js&"
export * from "./MedicalAlertDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee71505c",
  null
  
)

export default component.exports